import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { EditButton } from 'LegacyWeployDesignLanguage/buttons';

import { formatDateForView } from '../../utils/Date';

const Certification = styled.div`
  margin: ${props => props.theme.space.single} 0;
  padding-bottom: ${props => props.theme.space.quarter};
`;

const Header = styled.div`
  color: ${props => props.theme.colors.text.primary};
  font-weight: bold;
  margin-bottom: ${props => props.theme.space.quarter};
  flex-grow: 1;
`;

const Headers = styled.div`
  display: flex;
  justify-content: flex-end;
`;

class Certifications extends Component {
  render() {
    const { certifications, onEdit } = this.props;

    return (
      <Fragment>
        { certifications.map((certificationData) => {
          const {
            id,
            name,
            issuingOrganization,
            issueDate,
            expiryDate,
          } = certificationData;

          return (
            <Certification key={id}>
              <Headers>
                <Header>{`${name} - ${issuingOrganization}`}</Header>
                {onEdit && <EditButton onClick={() => onEdit(certificationData)} />}
              </Headers>
              {issueDate && <div>Issued on {formatDateForView(issueDate)}</div>}
              {expiryDate && <div>Expires on {formatDateForView(expiryDate)}</div>}
            </Certification>
          );
        })}
      </Fragment>
    );
  }
}

Certifications.propTypes = {
  certifications: PropTypes.array,
  onEdit: PropTypes.func,
};

Certifications.defaultProps = {
  certifications: [],
  onEdit: null,
};

export default Certifications;
